"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockSapphireOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockSapphireOracleFactory = /** @class */ (function (_super) {
    __extends(MockSapphireOracleFactory, _super);
    function MockSapphireOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockSapphireOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockSapphireOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockSapphireOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockSapphireOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockSapphireOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockSapphireOracleFactory;
}(contracts_1.ContractFactory));
exports.MockSapphireOracleFactory = MockSapphireOracleFactory;
var _abi = [
    {
        constant: true,
        inputs: [],
        name: "currentPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "mockTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_price",
                type: "uint256",
            },
        ],
        name: "setPrice",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "setTimestamp",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x6080604052678ac7230489e80000600055600060015534801561002157600080fd5b506101b3806100316000396000f3fe608060405234801561001057600080fd5b50600436106100575760003560e01c806340792ebb1461005c57806391b7f5ed1461007a57806396a0e5e31461008f5780639d1b464a146100a5578063a0a2b573146100ad575b600080fd5b6100646100c0565b6040516100719190610126565b60405180910390f35b61008d6100883660046100f1565b6100c6565b005b6100976100cb565b604051610071929190610134565b6100646100d5565b61008d6100bb3660046100f1565b6100db565b60015481565b600055565b6000546001549091565b60005481565b600155565b80356100eb81610159565b92915050565b60006020828403121561010357600080fd5b600061010f84846100e0565b949350505050565b61012081610156565b82525050565b602081016100eb8284610117565b604081016101428285610117565b61014f6020830184610117565b9392505050565b90565b61016281610156565b811461016d57600080fd5b5056fea365627a7a723158208010e8570fdf8795e6bd4d875556c4bd84db1790372faa948a36aad00b8adaad6c6578706572696d656e74616cf564736f6c63430005100040";
